(() => {
  if (window.elPearlContactInquiryLoaded) return;
  window.elPearlContactInquiryLoaded = true;

  const cleanText = (value, limit) => (value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);
  const prefillProductInquiry = (scope = document) => {
    const params = new URLSearchParams(window.location.search);
    const title = cleanText(params.get('product_title'), 240);
    const productPath = params.get('product_url');
    if (!title || !productPath) return;
    let productUrl;
    try { productUrl = new URL(productPath, window.location.origin); } catch { return; }
    if (productUrl.origin !== window.location.origin) return;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(productUrl.pathname)) return;
    const urlVariant = productUrl.searchParams.get('variant') || '';
    const explicitVariant = params.get('variant_id') || '';
    if (urlVariant && explicitVariant && urlVariant !== explicitVariant) return;
    const variantId = explicitVariant || urlVariant;
    if (variantId && !/^\d+$/.test(variantId)) return;
    productUrl.search = '';
    productUrl.hash = '';
    if (variantId) productUrl.searchParams.set('variant', variantId);
    const variantTitle = variantId ? cleanText(params.get('variant_title'), 240) : '';

    scope.querySelectorAll('textarea[data-el-product-inquiry]').forEach((field) => {
      if (field.value.trim() || field.dataset.elInquiryTouched === 'true' || field.dataset.elInquiryPrefilled === 'true') return;
      const lines = [field.dataset.elProductIntro, title];
      if (variantTitle && variantTitle.toLowerCase() !== 'default title') lines.push(`${field.dataset.elVariantLabel}: ${variantTitle}`);
      if (variantId) lines.push(`${field.dataset.elVariantIdLabel}: ${variantId}`);
      lines.push(productUrl.href, '', field.dataset.elProductQuestion, '');
      field.value = lines.join('\n');
      field.dataset.elInquiryPrefilled = 'true';
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches('textarea[data-el-product-inquiry]')) event.target.dataset.elInquiryTouched = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prefillProductInquiry(), { once: true });
  else prefillProductInquiry();
  document.addEventListener('shopify:section:load', (event) => prefillProductInquiry(event.target));
})();
